import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TrustedBrokers from '../components/TrustedBrokers';
import ServicesElite from '../components/ServicesElite';
import WhyExcelence from '../components/WhyExcelence';
import CaseStudies from '../components/CaseStudies';
import RecruitmentCTA from '../components/RecruitmentCTA';
import Reviews from '../components/Reviews';
import FooterCTABand from '../components/FooterCTABand';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TrustedBrokers />
        <ServicesElite />
        <WhyExcelence />
        <CaseStudies />
        <RecruitmentCTA />
        <Reviews />
        <FooterCTABand />
      </main>
      <Footer />
    </>
  );
};

export default Home;
